<template>
    <el-select v-if="componentShow" ref="zmSimpleTable" :clearable="clearable" filterable v-model="newValue" :name="name"
               :tabindex="tabindex" style="width: 100%"  :multiple="multiple" :allow-create="allowCreate"
               :default-first-option="defaultFirstOption" @blur="selBlur"
               :disabled="disabled" placeholder="" :collapse-tags="collapseTags" @change="selectChange">
        <el-option v-for="item in tablelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: "SimpleTable",
         beforeCreate() {
		this.i18nPage = 'component.SimpleTable.';
	},
        props: {
            tableName:{
                type:String
            },
            value:{
                type:[String,Array]
            },
            clearable:{
                type:Boolean,
                default:true
            },
            multiple:{
                type:Boolean,
                default:false
            },
            allowCreate:{
                type:Boolean,
                default:false
            },
            defaultFirstOption:{
                type:Boolean,
                default:true
            },
            disabled:{
                type:Boolean,
                default:false
            },
            collapseTags:{
                type:Boolean,
                default:false
            },
            tabindex:{
                type:String
            },
            filterData:{
                type:Function
            },
            name:{
                type:String
            },
            blurClosePanel:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                tablelist:[],
                componentShow:true,
                initCount:0,
                i18nPage : 'component.SimpleTable.'
            }
        },
        watch:{
            '$i18n.locale'(){
                this.getTableList()
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            setValue(val){
                if(val){
                    if(!this.tablelist || this.tablelist.length == 0){
                        this.getTableList();
                    }
                    let valObj = this.tablelist.find((item)=>{
                        return item.value === val;
                    });
                    if(valObj){
                        this.newValue = val;
                    }
                }
            },
            getTableList(){
                if(this.tableName){
                    var _params = {tableName:this.tableName }
                    var res = this.$global.getCallTableSimple(_params,this.$i18n.locale);
                    if(res && res.data && res.data.length > 0){
                        if(this.filterData){
                            this.tablelist = this.filterData(res.data)
                        }else{
                            this.tablelist = res.data;
                        }
                    } else {
                        if(this.initCount < 10){
                            let simpleDetail = this.$util.get("tableSimpleDetail");
                            if(!simpleDetail || simpleDetail.length == 0){
                                setTimeout(() => {
                                    this.initCount ++;
                                    this.getTableList();
                                },5000)
                            }
                        }else{
                            this.$util.show(this.$t(this.i18nPage+'选项表配置加载失败'),1)
                        }
                    }
                }
            },
            selectChange(val){
                //多选返回选择数据数组  单选返回选择对象
                if(this.multiple){
                    if(val && val.length > 0){
                        var returnArr = [];
                        this.tablelist.forEach((item, index) => {
                            if(val.indexOf(item.value) > -1){
                                returnArr.push(item);
                            }
                        });
                        this.$emit('change',returnArr);
                    }else{
                        this.$emit('change',[]);
                    }
                }else{
                    let obj = {};
                    obj = this.tablelist.find((item)=>{
                        return item.value === val;
                    });
                    this.$emit('change',obj);
                }
            },
            focus(){
                this.$refs['zmSimpleTable'].focus();
            },
            blur(event){
                this.$refs['zmSimpleTable'].blur();
            },
            selBlur(){
                if(this.blurClosePanel){
                    setTimeout(() => {
                        this.$refs['zmSimpleTable'].visible = false;
                    },100)
                }
            }
        },
        created(){
            console.log('tablesimple init')
            this.getTableList();
        },
        beforeDestroy(){
            this.tablelist = [];
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SimpleTable/index.vue